import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import ViewStudent from "../components/ViewStudentPage";


const ViewStudentAssessment = () => {
  return (
    <>

        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>View Portflio and Assessment  </h5><Breadcrumb title="View Student" /></div>

        {/* UsersListLayer */}
        <ViewStudent />


    </>
  );
};

export default ViewStudentAssessment; 